import { FormEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Button, Typography } from '@mui/material';

import { EStationVariant } from '@/config/station';

import { GenericModalFooter } from '@/components/modal/GenericModalFooter';
import { RadioGroup } from '@/components/radioGroup/RadioGroup';
import type { TStepComponentProps } from '@/components/stepper/types';

import type { TCreateStationForm } from '@/types/station';

import { styles as formStyles } from '../Form.styles';
import { STATION_TYPES } from './config';

export const StationType = ({ data, onSubmit }: TStepComponentProps<TCreateStationForm>) => {
  const { t } = useTranslation();
  const [selectedType, setSelectedType] = useState(
    data.type || EStationVariant.GASOLINE_AND_DIESEL,
  );

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();

    onSubmit({
      type: selectedType,
    });
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={formStyles.form}>
      <Box sx={formStyles.content}>
        <Typography variant="h6" sx={formStyles.title}>
          {t('stationSetup.stationType.title')}
        </Typography>

        <RadioGroup
          variant="button"
          value={selectedType}
          options={STATION_TYPES}
          onChange={setSelectedType}
          renderOption={({ label }) => t(label)}
          sx={{ paddingTop: 2, gap: 3 }}
        />

        <Typography variant="caption" color="text.secondary" component="p" marginTop={4}>
          {t('stationSetup.stationType.details')}
        </Typography>
      </Box>

      <GenericModalFooter sx={formStyles.footer} squareButtons>
        <Box sx={formStyles.controls}>
          <Button type="submit" disabled={!selectedType}>
            {t('common.continue')}
          </Button>
        </Box>
      </GenericModalFooter>
    </Box>
  );
};
